export const PhoneInput = "phoneInput";

const template = `
    <input id="{{ctrl.name}}" 
           class="form-control fs-anim-lower"
           name="{{ctrl.name}}"
           type="tel"
           placeholder="{{ctrl.placeholder}}"
           ng-required="ctrl.required"
           ng-model="ctrl.value"
           ui-mask="{{ctrl.mask}}"
           ui-mask-placeholder
           ng-change="ctrl.valueChanged()"
           ui-options="ctrl.maskOptions">
`;

export function phoneInput() {
    return {
        template,
        bindings: {
            value: "<",
            name: "@",
            placeholder: "@",
            required: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: PhoneInputController
    };
}

export class PhoneInputController {

    public value: string;
    public name: string;
    public placeholder: string;
    public required: boolean;
    public onChange: Function;

    public mask: string;

    public maskOptions = {
        maskDefinitions: {
            "9": /\d/,
            "+": /\+/,
            "*": /[0-9+]/
        },
        allowInvalidValue: true
    };

    private phoneMasks = {
        defaultMask: "*999 999 999",
        mobileMask: "9999 999 999",
        mobileIntlMask: "+99 999 999 999",
        landlineMask: "(99) 9999 9999",
        landlineIntlMask: "(+99) 9 9999 9999",
        freeCallMask: "9999 999 999",
        freeCallIntlMask: "*99 999 999 999"
    };

    public $onInit() {
        if (this.required == null) {
            this.required = false;
        }
        if (this.name == null) {
            this.name = "phone";
        }
        this.mask = this.phoneMasks.defaultMask;
    }

    public valueChanged() {
        if (this.value == null) {
            this.mask = this.phoneMasks.defaultMask;
        } else if (this.value.startsWith("+")) {
            this.setIntlMask(this.value);
        } else {
            this.setDomesticMask(this.value);
        }
        if (this.isValidValue(this.value)) {
            this.onChange({value: this.value});
        }
    }

    private isValidValue(value: string): boolean {
        if (value == null || value === "") {
            return true;
        }
        const shrunk = this.mask.replace(/ /g, "");
        return value.length === shrunk.length;
    }

    private setDomesticMask(value: string) {
        if (value.length < 2) {
            this.mask = this.phoneMasks.mobileMask;
        } else {
            const prefix = value.substring(0, 2);
            if (prefix === "04") {
                this.mask = this.phoneMasks.mobileMask;
            } else if (prefix === "13" || prefix === "18") {
                this.mask = this.phoneMasks.freeCallMask;
            } else {
                this.mask = this.phoneMasks.landlineMask;
            }
        }
    }

    private setIntlMask(value: string) {
        if (value.length < 4) {
            this.mask = this.phoneMasks.mobileIntlMask;
        } else {
            const prefix = value.substr(0, 4);
            if (prefix === "+614") {
                this.mask = this.phoneMasks.mobileIntlMask;
            } else {
                this.mask = this.phoneMasks.landlineIntlMask;
            }
        }
    }
}
